export const AVAILABLE_LANGUAGES: string[] = ['en', 'ko'];

export const getLanguage = (): string => {
  try {
    const languageDetected = navigator.language;
    const processedLanguage = languageDetected.includes('-')
    ? languageDetected.split('-')[0]
    : languageDetected;

    return AVAILABLE_LANGUAGES.includes(processedLanguage) ? processedLanguage : AVAILABLE_LANGUAGES[0]

  } catch (e) {return AVAILABLE_LANGUAGES[0]}
}

export const parseLanguageFromPathName = (pathName: string) => {
  try {
    const languageAvailable = ['en', 'ko']
    const parsedLanguage = pathName.split('/')[1]
    if (languageAvailable.includes(parsedLanguage)) {
      return parsedLanguage
    } else {
      return 'en'
    }
  } catch (e) {return null}
}